import React, {Component} from 'react';
import classnames from 'classnames';
import './BreadrumbsNavigation.scss';

class BreadrumbsNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isBreadcrumbOpen: false
    };
  }

  goToFolder(folderId) {
    let folderStack = [];
    if (folderId) {
      folderStack = this.state.folderStack;

      const index = folderStack.indexOf(folderStack.find(folder => folder.id === folderId));
      folderStack.splice(index + 1);
    }

    this.setState({
      folderStack
    });
  }

  onMobileMenuClick(folderId) {
    if (this.state.isBreadcrumbOpen || !folderId) {
      this.props.onMenuClick(folderId);
    }

    this.setState({
      isBreadcrumbOpen: !this.state.isBreadcrumbOpen
    });
  }

  render() {
    return (
      <div className="breadcrumbs">
        <div className="desktop">
          {this.props.rootMenu &&
            <div className="breadcrumb-container">
              <span className="sep">
                <i className="fa fa-chevron-right" />
              </span>
              <span className="bread-crumb">
                <a onClick={() => this.props.onMenuClick(null)}>
                  {this.props.rootMenu}
                </a>
              </span>
            </div>
          }

          {this.props.navigationMenu.length > 0 && this.props.navigationMenu.map(menu => (
            <div className="breadcrumb-container" key={menu.id}>
              <span className="sep">
                <i className="fa fa-chevron-right" />
              </span>
              <span className="bread-crumb">
                <a onClick={() => this.props.onMenuClick(menu.id)}>
                  {menu.file.name}
                </a>
              </span>
            </div>
          ))}
        </div>

        <div className={classnames('mobile', {
              open: this.state.isBreadcrumbOpen,
            })}>
          {this.props.rootMenu &&
            <div className="breadcrumb-container">
              <span className="sep">
                <i className="fa fa-chevron-right" />
              </span>
              <span>
                <a onClick={() => this.onMobileMenuClick(null)}>
                  {this.props.rootMenu}
                </a>
              </span>
            </div>
          }

          {this.props.navigationMenu.length > 0 && this.props.navigationMenu.map(menu => (
            <div className="breadcrumb-container" key={menu.id}>
              <span className="sep">
                <i className="fa fa-chevron-right" />
              </span>
              <span className="bread-crumb">
                <a onClick={() => this.onMobileMenuClick(menu.id)}>
                  {menu.file.name}
                </a>
              </span>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default BreadrumbsNavigation
